module.exports = __webpack_public_path__ + "img/zoeva2.adc97b1e.jpg";